//
//
//
//
//
//
//
//
//
//
//
//

import modalAware from '../common/mixins/modalAware';
import MainContainer from './MainContainer.vue';
// import LeftDrawer from './LeftDrawer.vue';
import Confirmation from './Confirmation.vue';
import Alert from './Alert';
import Wait from './Wait';

export default {
  name: 'AppContainer',
  mixins: [modalAware],
  components: {
    Wait,
    Alert,
    Confirmation,
    // LeftDrawer,
    MainContainer,
  },
  mounted() {
    if (!this.modalOpen && document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    }
  },
  watch: {
    modalOpen() {
      document.body.style.overflow = this.modalOpen ? 'hidden' : '';
    },
  },
};
